jQuery(document).ready(function(){
  setTimeout(function(){  
      jQuery(".bcpo-image-parent").each(function(){
         var title = jQuery(this).find(".bcpo-front-image-option").val();
         var data_price = jQuery(this).find(".bcpo-front-image-option").attr("data-price");
        if(data_price || data_price == "undefined"){
          jQuery(this).append("<span class='bcpo-front-image-title'>"+title+"- (£"+data_price+")</span>");
        }else{
          jQuery(this).append("<span class='bcpo-front-image-title'>"+title+"</span>");
        }
      });
  },3000);
  jQuery(document).on(".tpo_option_type_label_wrapper","click",function(){
      jQuery(this).prev().trigger("click");
      console.log("tpo_option-type-image-swatches-wrapper");
  });
});

jQuery(document).ready(function(){
function showmorebtn() {
  var read_more = $(".read-more").length;
    jQuery(".tpo_option-type-image-swatches-wrapper").each(function(i) {
      console.log("loaded.");
         var swatches_class = jQuery(this).addClass("tpo_option_swatches_"+i);
         var length = jQuery(this).find(".tpo_swatches-label_position").length;
         
          if(length > 10){
              if(read_more == 0) {
                jQuery(this).after('<div class="read-more active">Show More</div>');
                jQuery(this).after('<div class="read-less">Show Less</div>');
              }
          }
         
        jQuery(this).find(".tpo_swatches-label_position").each(function(i) {
           if(i < 10) {
              jQuery(this).addClass("active");
              var swatches = jQuery(this).innerHeight();
              //jQuery(this).css("min-height",swatches+"px");
            }else{
              jQuery(this).addClass("hide");
            }
        });
       });
    
    jQuery(".read-more").on('click', function(){
        jQuery(this).parent().find(".tpo_swatches-label_position").addClass("active");
        jQuery(this).removeClass("active");
        jQuery(this).prev(".read-less").addClass("active");
        jQuery(".tpo_option-type-image-swatches-wrapper").each(function(i) {
            jQuery(this).find(".tpo_swatches-label_position").each(function(i) {
                var swatches = jQuery(this).find(".tpo_option_type_label_wrapper").innerHeight();
                //jQuery(this).find(".tpo_option_type_label_wrapper").css("min-height",swatches+"px");
            });
        });
    });
    
    jQuery(".read-less").on('click', function(){
        jQuery(this).parent().find(".tpo_swatches-label_position").removeClass("active");
        jQuery(this).parent().find(".tpo_option-type-image-swatches-wrapper").each(function() {
           jQuery(this).find(".tpo_swatches-label_position").each(function(i) {
               if(i < 10) {
                   jQuery(this).addClass("active");
               }
            });
        });
        jQuery(this).removeClass("active");
        jQuery(this).next(".read-more").addClass("active");
        var parent_c = jQuery(this).parent().attr("class");
        
        jQuery('html, body').animate({
          scrollTop: jQuery("."+parent_c).offset().top - 200
        }, 2000);
    });
}
function loadmorebtn() {
  var load_more = $(".load-more").length;
  jQuery(".dynamic-variant-input-wrap").each(function(i) {
     var length = jQuery(this).find(".dynamic-variant-button").length;
       if(length > 10){
            if(load_more == 0) {
              jQuery(this).after('<div class="load-more active">Show More</div>');
              jQuery(this).after('<div class="load-less">Show Less</div>');
            }
        }
        jQuery(this).find(".dynamic-variant-button").each(function(i) {
           if(i < 10) {
              jQuery(this).addClass("active");
            }else{
              jQuery(this).addClass("hide");
            }
        });
  });
  
  jQuery(".load-more").on('click', function(){
      jQuery(this).parent().find(".dynamic-variant-button").addClass("active");
      jQuery(this).removeClass("active");
      jQuery(this).prev(".load-less").addClass("active");
  });
  
  jQuery(".load-less").on('click', function(){
        jQuery(this).parent().find(".dynamic-variant-button").removeClass("active");
        jQuery(this).parent().find(".dynamic-variant-button").each(function() {
           jQuery(this).find(".dynamic-variant-button").each(function(i) {
               if(i < 10) {
                   jQuery(this).addClass("active");
               }
            });
        });
        jQuery(this).removeClass("active");
        jQuery(this).next(".load-more").addClass("active");
        var parent_c = jQuery(this).parent().attr("class");
   
        jQuery('html, body').animate({
          scrollTop: jQuery(".product__variants-wrapper").offset().top - 200
        }, 2000);
    });
}
  
     setTimeout(function(){
        showmorebtn();
        loadmorebtn()
     },3000);
   
     jQuery(window).resize(function(){
        var read_more = $(".read-more").length;
        if(read_more == 0) {
            showmorebtn();
        }
        var load_more = $(".load-more").length;
        if(load_more == 0) {
            loadmorebtn();
        }
     });
  
     jQuery(window).scroll(function() {
        var read_more = $(".read-more").length;
        if(read_more == 0) {
           //showmorebtn();
        }
        var load_more = $(".load-more").length;
        if(load_more == 0) {
            //loadmorebtn();
        }
     });
  
     jQuery(document).on('click','body *',function(){
        var read_more = $(".read-more").length;
        if(read_more == 0) {
           showmorebtn();
        }
        var load_more = $(".load-more").length;
        if(load_more == 0) {
            loadmorebtn();
        }
     });
  
	   jQuery(document).on('click','.dynamic-variant-button',function() {
      $('select option').removeAttr( "hidden" )
      var label = $(this).attr("data-option-value");
      var product_option = $(this).attr("data-label");
      var variantsJson =  $("#product_var").attr("data-items");
      var json = $.parseJSON(variantsJson);
      $(this).parent().parent().next(".product__option").find(".product__label").find("span").text("Select Options");
      $(".select-wrapper #option2").empty();
      $(".select-wrapper #option2").append("<option value='Select Options' data-ioshidden selected='selected' hidden>Select Options</option>");
        $(json).each(function (i, val) {
            $.each(val, function (key, var_data) {
              if(var_data == label) {
               var title = val.option2;
               var option_i = val.option2.toLowerCase();
               var option_id =  val.id;
                //console.log(option_id);
                 $(".select-wrapper #option2").append("<option data-value-handle='"+option_i+"--"+i+"' value='"+title+"' option-id='"+option_id+"'>"+title+"</option>");
              }
            });
        });
   
       $(".select-wrapper #option2 option").each(function (k, data) {
         $(this).removeAttr("selected");
           if(k == 1){
             $(this).attr("selected","selected");
             var title = $(this).val();
             var option_id = $(this).attr("option-id");
             $(this).parent().parent().prev(".product__label-wrapper").find(".product__label").find("span").text(title);
             //$(this).parent().val(title).on("change");
           }
       });
     
       $(".dynamic-variant-button.selected").addClass("changed");
         
      setTimeout(
        function() 
        {
          $(".dynamic-variant-button.changed").trigger("click");
          $(".dynamic-variant-button.selected").removeClass("changed");
          //console.log("test");
        }, 1500);
     
    });
    
});






$(document).on('click', '.samples_img',function() {
       if (!$(this).parent('div').hasClass('active')) {
           var optimage_length = $(".optImage.form").length;
           if(optimage_length<=9){
               $(this).parent('div').addClass('active');
               var img_filterId = $(this).attr('data-id');
               var img_filterText = $(this).attr('data-text');
               var img_src =  $(this).children('img').attr('src');
               $(".optimage_error").remove();
               $('.sample_requested').before('<div class="optImage form"><i class="fas fa-times" data-name="' + img_filterText + '" data-id="' + img_filterId + '"></i><span data-id="' + img_filterId + '"><img loading="lazy" loading="lazy" loading="lazy" loading="lazy" loading="lazy" src="' + img_src + '" alt="" class="responsive" /><p style="">' + img_filterText + '</p></span></div>');
               var sample_requested = $('.sample_requested .classic_rounded-input').val();
               if(sample_requested == ""){
                  $('.sample_requested .classic_rounded-input').val(img_filterText);
               }else{
                  var sample_old = $('.sample_requested .classic_rounded-input').val();
                  $('.sample_requested .classic_rounded-input').val(sample_old+', \n'+img_filterText);
               }
           }else{
             $(".optimage_error").remove();
             $(".gfb__footer").before('<span class="optimage_error">Please add samples less than (or) equal to 10.</span>');
           }
         $('html,body').animate({
             scrollTop: $(".globo-form-app").offset().top
         }, 1000);
       }
   });
  $(document).on('click', '.optImage.form i',function() {
      var img_data = new Array();
       $(this).parent('div').remove();
       var id = $(this).attr('data-id');
       $('.smpl_' + id + '').parent('div').removeClass('active');
       var optimage_length = $(".optImage.form").length;
       if(optimage_length<=9){
           $(".optImage.form").each(function(i) {
               img_data.push($(this).find("i").attr("data-name"));
           });
          $('.sample_requested .classic_rounded-input').val(img_data.join(', \n'));
       }
   });
  jQuery(document).on('click','.go_to_top',function(){
        jQuery("html,body").animate({scrollTop: 100}, 2000);
  });
  jQuery(window).on('load', function(){
     jQuery(".rich-text__inner").each(function(){
        var text_count = jQuery(this).find(".section-blocks__text").text().length;
         if(text_count > 1500)  {
              var test2 = jQuery(this).find(".section-blocks__text").html();
              jQuery(this).append("<span class='btn btn--text show_more'> Show More </span>");
              jQuery(this).append("<span class='btn btn--text show_less hide'> Show Less </span>");
         }
    });
  });
  jQuery(document).on('click','.show_more',function(){
    jQuery(this).parent().find(".section-blocks__text").addClass("auto_height");
    jQuery(this).parent().find(".show_more").addClass("hide"); 
    jQuery(this).parent().find(".show_less").removeClass("hide"); 
  });
  jQuery(document).on('click','.show_less',function(){
    jQuery(this).parent().find(".section-blocks__text").removeClass("auto_height");
    jQuery(this).parent().find(".show_less").addClass("hide"); 
    jQuery(this).parent().find(".show_more").removeClass("hide");
    var go_top = jQuery(this).parent().find(".section-blocks__text");
    jQuery('html,body').animate({
             scrollTop: jQuery(go_top).offset().top - 150
     }, 1000);
  });


  